import React, { useState } from 'react';
import SoundManager from '../../utils/SoundManager';
import './Hud.css';

const Hud = ({ 
  score, 
  timeLeft, 
  matchedCount, 
  totalPairs, 
  combo,
  isPaused,
  currentHighScore = 0,
  isBeatingRecord = false,
  onBack
}) => {
  const [isMuted, setIsMuted] = useState(SoundManager.isMuted());

  const handleToggleMute = () => {
    const newMutedState = SoundManager.toggleMute();
    setIsMuted(newMutedState);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const isWarning = timeLeft < 30;

  const handleBackClick = () => {
    SoundManager.play('back');
    if (onBack) onBack();
  };

  return (
    <div className="hud">
      {/* Botão Voltar */}
      <button
        className="hud-back-btn"
        onClick={handleBackClick}
        aria-label="Voltar aos Níveis"
      >
        ← Voltar
      </button>

      {/* Timer */}
      <div className={`hud-timer ${isWarning ? 'warning' : ''}`}>
        <span className="timer-value">{formatTime(timeLeft)}</span>
        {isPaused && <span className="paused-badge">⏸</span>}
      </div>

      {/* Pares (centro) */}
      <div className="hud-progress">
        <span className="hud-progress-text">
          {matchedCount}/{totalPairs}
        </span>
        <span className="hud-progress-label">pares</span>
      </div>

      {/* Score */}
      <div className="hud-score">
        <span className="hud-score-value">{score.toLocaleString()}</span>
        <span className="hud-score-label">pts</span>
        {isBeatingRecord && (
          <span className="hud-record-badge">🏆 RECORDE!</span>
        )}
      </div>

      {/* Som */}
      <button
        className={`sound-toggle ${isMuted ? 'muted' : ''}`}
        onClick={handleToggleMute}
        title={isMuted ? 'Ativar Som' : 'Desativar Som'}
        aria-label={isMuted ? 'Ativar Som' : 'Desativar Som'}
      >
        {isMuted ? '🔇' : '🔊'}
      </button>

      {/* Combo badge (sobreposto, posição absoluta) */}
      {combo > 1 && (
        <div className="hud-combo-badge">
          🔥 x{combo}
        </div>
      )}
    </div>
  );
};

export default Hud;
